export class ItfDatabase {
  constructor(
    public id: number | null,
    public nroLibreta: number | null,
    public nombre: string,
    public apellido: string,
    public fcNacimiento?: string,
    public sexo?: 'M' | 'F',
    public gup?: number | null,
    public nuCertDan?: string | null,
    public dan?: number | null,
    public ngb?: string,
    public nacionalidad?: string,
    public emailNgb?: string,
    
    // Payment fields (from latest payment)
    public matriculaFcPago?: string | null,
    public matriculaAnio?: number | null,
    public matriculaVigente?: boolean,
    public matriculaMonto?: number | null,
    
    // Audit fields
    public activo?: boolean,
    public createdAt?: string,
    public updatedAt?: string,
    public createdBy?: number | null,
    
    // Relations (when included)
    public estudiante?: {
      nroLibreta: number;
      nombre: string;
      apellido: string;
      documento: string;
    } | null
  ) {}

  static fromApiData(data: any): ItfDatabase {
    return new ItfDatabase(
      data.id,
      data.nroLibreta || data.nro_libreta,
      data.nombre,
      data.apellido,
      data.fcNacimiento || data.fc_nacimiento,
      data.sexo,
      data.gup,
      data.nuCertDan || data.nu_cert_dan,
      data.dan,
      data.ngb,
      data.nacionalidad,
      data.emailNgb || data.email_ngb,
      data.matriculaFcPago || data.matricula_fc_pago,
      data.matriculaAnio || data.matricula_anio,
      data.matriculaVigente || data.matricula_vigente,
      data.matriculaMonto || data.matricula_monto,
      data.activo !== undefined ? data.activo : true,
      data.createdAt || data.created_at,
      data.updatedAt || data.updated_at,
      data.createdBy || data.created_by,
      data.estudiante || null
    );
  }

  // This method should serialize the CURRENT state, not original data
  toJSON() {
    return {
      id: this.id,
      nroLibreta: this.nroLibreta,
      nombre: this.nombre,
      apellido: this.apellido,
      fcNacimiento: this.fcNacimiento,
      sexo: this.sexo,
      gup: this.gup,
      nuCertDan: this.nuCertDan,
      dan: this.dan,
      ngb: this.ngb,
      nacionalidad: this.nacionalidad,
      emailNgb: this.emailNgb,
      activo: this.activo,
      createdBy: this.createdBy
    };
  }

  get nombreCompleto(): string {
    return `${this.apellido}, ${this.nombre}`;
  }

  get gradoActual(): string {
    if (this.dan) return `${this.dan}° DAN`;
    if (this.gup) return `${this.gup}° GUP`;
    return 'Sin graduación';
  }

  get estadoPago(): string {
    if (!this.matriculaVigente) return '⚠ VENCIDO';
    return '✓ VIGENTE';
  }
}